import { Link } from 'react-router-dom';
import { Icon } from '../design/Icon';
import { useAppTo } from './links';
import { SERVICES, isAvailable } from './services';

const SOON = 'Bientôt disponible';

/** « Tous les services » (mobile) : la grille des services, disponibles ou non, plus « Ajouter » en pointillé. */
export function AppsGrid({ onNavigate }: { onNavigate: () => void }) {
  const to = useAppTo();
  return (
    <section className="sh-apps" aria-labelledby="sh-apps-title">
      <h1 id="sh-apps-title">Tous les services</h1>
      <div className="sh-apps__grid">
        {SERVICES.map((s) =>
          isAvailable(s) ? (
            <Link key={s.id} to={to(s.path!)} className="sh-apps__card" onClick={onNavigate}>
              <Icon name={s.icon} size={28} />
              {s.label}
            </Link>
          ) : (
            <button key={s.id} type="button" className="sh-apps__card" aria-disabled="true" title={SOON}>
              <Icon name={s.icon} size={28} />
              <span>{s.label}</span>
              <span className="sh-apps__soon">Bientôt</span>
            </button>
          ),
        )}
        <button type="button" className="sh-apps__card sh-apps__card--add" aria-disabled="true" title={`Ajouter un service · ${SOON}`}>
          <Icon name="plus" size={28} />
          Ajouter
        </button>
      </div>
    </section>
  );
}
